/*
  Modal "COMPRAR" para cards de produto (produtos relacionados).
  Usa delegacao no document pra funcionar com cards injetados de forma assincrona
  (product-recommendations). Abre/fecha um <dialog> e troca a variante selecionada.
*/
(function () {
  'use strict';

  function openDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-pc-open]');
    if (opener) {
      var wrap = opener.closest('.pc-buy-modal');
      openDialog(wrap && wrap.querySelector('[data-pc-dialog]'));
      return;
    }

    var closer = event.target.closest('[data-pc-close]');
    if (closer) {
      closeDialog(closer.closest('dialog'));
      return;
    }

    /* Clique fora do conteudo (no backdrop) fecha */
    if (event.target.matches('.pc-buy-modal__dialog')) {
      closeDialog(event.target);
    }
  });

  /* Fecha o modal quando o produto e adicionado ao carrinho.
     O <product-form> do Dawn publica PUB_SUB_EVENTS.cartUpdate no add com sucesso. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      document.querySelectorAll('.pc-buy-modal__dialog[open]').forEach(closeDialog);
    });
  }

  /* Troca de tamanho -> atualiza o id da variante no form + o preco exibido */
  document.addEventListener('change', function (event) {
    var input = event.target.closest('.pc-buy-modal__size input');
    if (!input) return;

    var modal = input.closest('.pc-buy-modal');
    if (!modal) return;

    var idField = modal.querySelector('.product-variant-id');
    if (idField) idField.value = input.value;

    var price = input.getAttribute('data-price');
    var priceEl = modal.querySelector('.price-for');
    if (price && priceEl) priceEl.textContent = price;
  });

  /* Hover-buy inline (desktop): troca de tamanho -> atualiza o id da variante no form */
  document.addEventListener('change', function (event) {
    var hoverInput = event.target.closest('.card-hover-buy__size input');
    if (!hoverInput) return;

    var hoverWidget = hoverInput.closest('.card-hover-buy');
    if (!hoverWidget) return;

    var hoverIdField = hoverWidget.querySelector('.product-variant-id');
    if (hoverIdField) hoverIdField.value = hoverInput.value;
  });

  /* O card inteiro tem um link invisivel cobrindo a imagem (pra navegar pro
     produto). Enquanto o mouse estiver de fato em cima do .card-hover-buy,
     desativa esse link (via classe .card-wrapper--hover-buy-active) pra nao
     roubar o clique dos botoes de tamanho / adicionar a sacola. Fora dessa
     area, a imagem continua navegando pro produto normalmente. */
  document.addEventListener('mouseover', function (event) {
    var wrapper = event.target.closest('.card-wrapper');
    if (!wrapper || wrapper.hoverBuyBound) return;

    var widget = wrapper.querySelector('.card-hover-buy');
    if (!widget) return;

    wrapper.hoverBuyBound = true;

    function onMove(moveEvent) {
      var rect = widget.getBoundingClientRect();
      var inside = moveEvent.clientX >= rect.left
        && moveEvent.clientX <= rect.right
        && moveEvent.clientY >= rect.top
        && moveEvent.clientY <= rect.bottom;
      wrapper.classList.toggle('card-wrapper--hover-buy-active', inside);
    }

    function onLeave() {
      wrapper.classList.remove('card-wrapper--hover-buy-active');
      wrapper.removeEventListener('mousemove', onMove);
      wrapper.removeEventListener('mouseleave', onLeave);
      wrapper.hoverBuyBound = false;
    }

    wrapper.addEventListener('mousemove', onMove);
    wrapper.addEventListener('mouseleave', onLeave);
  });
})();
